var AppSwiper = {
    init: function(id, params){
        var mySwiper = new Swiper (id, params);
        return mySwiper;
    }
}